var banner_click = 0;
var banner_right = 1; //解决第一次右边点击没反应
var banner_left = 0; //解决第一次右边点击没反应
$('.Lunbo-banner-l').click(function () { //当点击左边按钮
    for (var i = 1; i < 6; i++) {
        $('.add-show' + i).removeClass('add-show' + i);
    }
    banner_click += 1;
    // alert(click);
    if (banner_click >= 7) banner_click = 1;
    if (!banner_left){ banner_click = 2;banner_left = 1;} //解决第一次右边点击没反应
    banner_right = 1;
    $('.banner li:nth-of-type(' + (((banner_click + 0) <= 6) ? (banner_click + 0) : (banner_click + 0 - 6)) + ')').attr('class', 'banner4 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 1) <= 6) ? (banner_click + 1) : (banner_click + 1 - 6)) + ')').attr('class', 'banner1 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 2) <= 6) ? (banner_click + 2) : (banner_click + 2 - 6)) + ')').attr('class', 'banner2 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 3) <= 6) ? (banner_click + 3) : (banner_click + 3 - 6)) + ')').attr('class', 'banner3 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 4) <= 6) ? (banner_click + 4) : (banner_click + 4 - 6)) + ')').attr('class', 'banner4 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 5) <= 6) ? (banner_click + 5) : (banner_click + 4 - 6)) + ')').attr('class', 'banner4 banner-box');
    for (var i = 0; i < 5; i++) {
        $('.banner3').find('div').eq(i).addClass('add-show' + (i + 1));
    }
})
$('.Lunbo-banner-r').click(function () { //当点击右边按钮
    for (var i = 1; i < 6; i++) {
        $('.add-show' + i).removeClass('add-show' + i);
    }
    banner_click -= 1;
    if (banner_click <= 0) banner_click = 6;
    if (!banner_right) banner_click = 3; //解决第一次右边点击没反应
    banner_right = 1;
    $('.banner li:nth-of-type(' + (((banner_click + 0) <= 6) ? (banner_click + 0) : (banner_click + 0 - 6)) + ')').attr('class', 'banner4 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 1) <= 6) ? (banner_click + 1) : (banner_click + 1 - 6)) + ')').attr('class', 'banner1 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 2) <= 6) ? (banner_click + 2) : (banner_click + 2 - 6)) + ')').attr('class', 'banner2 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 3) <= 6) ? (banner_click + 3) : (banner_click + 3 - 6)) + ')').attr('class', 'banner3 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 4) <= 6) ? (banner_click + 4) : (banner_click + 4 - 6)) + ')').attr('class', 'banner4 banner-box');
    $('.banner li:nth-of-type(' + (((banner_click + 5) <= 6) ? (banner_click + 5) : (banner_click + 5 - 6)) + ')').attr('class', 'banner4 banner-box');
    for (var i = 0; i < 6; i++) {
        $('.banner3').find('div').eq(i).addClass('add-show' + (i + 1));
    }
})